import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './Search.module.scss';
import StatesContext from '../../context/states';
import MobileContext from '../../context/mobile';

const Search = (props) => {
  const states = useContext(StatesContext);
  const isMobile = useContext(MobileContext);
  const refForm = useRef(null);
  const refInput = useRef(null);
  const [currentQuery, setCurrentQuery] = useState('');
  const [vacText, setVacText] = useState('вакансий');
  const { updateOpenFilter, isInternship } = props;
  const { vacancyLength, updateQueriesSearch } = states;

  const submitHandler = (e) => {
    e.preventDefault();
    if (refInput.current.value === currentQuery) {
      return;
    }
    updateQueriesSearch(refInput.current.value);
    setCurrentQuery(refInput.current.value);
    // localStorage.setItem('cachedSearchQuery', refInput.current.value);
  };

  useEffect(() => {
    refInput.current.value = null;
  }, []);

  useEffect(() => {
    const forms = isInternship
      ? ['стажировка', 'стажировки', 'стажировок']
      : ['вакансия', 'вакансии', 'вакансий'];
    const num = vacancyLength % 10;
    const num2 = vacancyLength % 100;
    if (num === 1 && (num2 < 10 || num2 > 20)) {
      setVacText(forms[0]);
    } else if (num > 1 && num < 5 && (num2 < 10 || num2 > 20)) {
      setVacText(forms[1]);
    } else {
      setVacText(forms[2]);
    }
    // if (vacancyLength > 0) {
    //   refInput.current.value = localStorage.getItem('cachedSearchQuery');
    //   setCurrentQuery(localStorage.getItem('cachedSearchQuery'));
    // }
  }, [vacancyLength, isInternship]);

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <form
            action=""
            className={styles.form}
            ref={refForm}
            onSubmit={submitHandler}
          >
            {isMobile ? (
              <div className={styles.form__icon}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 11L15 15"
                    stroke="#008359"
                    strokeLinecap="round"
                  />
                  <circle cx="7.5" cy="7.5" r="5" stroke="#008359" />
                </svg>
              </div>
            ) : null}
            <input
              type="text"
              ref={refInput}
              className={styles.input}
              placeholder={
                isMobile
                  ? 'Специальность или название'
                  : 'Специальность или название вакансии'
              }
            />
            <button type="submit" className={styles.btn}>
              Найти
            </button>
          </form>
          {/* {isMobile && (
            <div
              className={styles.filter}
              onClick={() => {
                updateOpenFilter(true);
              }}
            >
              <svg
                width="15"
                height="13"
                viewBox="0 0 15 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="4"
                  y="9"
                  width="11"
                  height="1"
                  rx="0.5"
                  fill="#008359"
                />
                <circle cx="2.5" cy="9.5" r="2" stroke="#008359" />
                <rect
                  width="11"
                  height="1"
                  rx="0.5"
                  transform="matrix(-1 0 0 1 11 3)"
                  fill="#008359"
                />
                <circle
                  cx="2.5"
                  cy="2.5"
                  r="2"
                  transform="matrix(-1 0 0 1 15 1)"
                  stroke="#008359"
                />
              </svg>
            </div>
          )} */}
        </div>
        {/*{isInternship && (*/}
        {/*  <div className={styles.counter}>*/}
        {/*    {vacancyLength} {vacText}*/}
        {/*  </div>*/}
        {/*)}*/}
      </div>
    </>
  );
};

export default Search;
